import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import ExpenseAccordion from "./ExpenseAccordion";
import {
  useExpenseByEmployeeId,
  useExpenseListByDate,
  useUpdateExpeseAmounnt_ProceedToPayment,
} from "./hooks/useExpense";
import ReusableCard from "./ReusableCard";
import WithImageShadowCard from "./WithImageShadowCard";
import { Btn } from "../../AbstractElements";
import { useMemo, useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { Table } from "reactstrap";
import CardShimmer from "./CardShimmer";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import { COLORS } from "../../constants/colors";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { showToast } from "../../utils/toastUtils";

// 1. Define interface
interface Month {
  id: string | number;
  label: string;
}

// 2. Create months array
const months: Month[] = [
  { id: "01", label: "January" },
  { id: "02", label: "February" },
  { id: "03", label: "March" },
  { id: "04", label: "April" },
  { id: "05", label: "May" },
  { id: "06", label: "June" },
  { id: "07", label: "July" },
  { id: "08", label: "August" },
  { id: "09", label: "September" },
  { id: "10", label: "October" },
  { id: "11", label: "November" },
  { id: "12", label: "December" },
];

const EmployeeExpView = () => {
  const getEmployeeID = useLocation();
  const navigate = useNavigate();
  const {stopPolling, startPolling } = useExcelPolling();
  const { filter: expenseSlice_filter } = useSelector(
    (state: any) => state.expense
  );
  const {
    filter: AduditSlice_filter,
    auditScreenStatus: auditScreenStatus_redux,
  } = useSelector((state: any) => state.audit);
  const employeeId = getEmployeeID?.state?.id || 0;

  const month = AduditSlice_filter.filter.month.id || "";
  const monthNumber: number = month.split("-")[1];

  const MonthString = months.find((it) => it.id == monthNumber);
  const location = useLocation();
  const { auditScreenStatus } = location.state || {};

  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");

  const getEmployeeExpense = useExpenseByEmployeeId({
    id: employeeId,
    params: {
      month:
        auditScreenStatus_redux === true
          ? AduditSlice_filter.filter.month.id
          : expenseSlice_filter.month.id,
      IsExpense: auditScreenStatus === undefined ? 1 : 0,
    },
    enable: true,
  });

  const getExpenseListbyDate = useExpenseListByDate({
    id: employeeId,
    params: {
      month:
        auditScreenStatus_redux === true
          ? AduditSlice_filter.filter.month.id
          : expenseSlice_filter.month.id,
      IsExpense: auditScreenStatus === undefined ? 1 : 0,
    },
    enable: !!employeeId,
  });

  const employeeExpense = getEmployeeExpense?.data?.data || [];
  const expenseListByDate = getExpenseListbyDate?.data?.data || [];
  const [modal, setModal] = useState(false);
  const { mutate: Procced_To_Payment } =
    useUpdateExpeseAmounnt_ProceedToPayment();

  const formateData = useMemo(
    () =>
      Object.entries(expenseListByDate || {}).map(
        ([key, value]: [string, any]) => ({
          ...value,
          date: key,
          employeeId: employeeId,
        })
      ),
    [expenseListByDate, employeeId]
  );

  const {
    totalExpenseApproved,
    totalFWCalls,
    totalNCA,
    totalExpenseSubmitted,
    totalExpenseAudited,
  } = useMemo(() => {
    return formateData.reduce(
      (acc, item) => {
        acc.totalExpenseApproved += Number(item.Approved) || 0;
        acc.totalFWCalls += Number(item.FW) || 0;
        acc.totalNCA += Number(item.NCA) || 0;
        acc.totalExpenseSubmitted += Number(item.Requested) || 0;
        acc.totalExpenseAudited += Number(item.Final) || 0; // same as totalExpenseApproved?
        return acc;
      },
      {
        totalExpenseApproved: 0,
        totalFWCalls: 0,
        totalNCA: 0,
        totalExpenseSubmitted: 0,
        totalExpenseAudited: 0,
      }
    );
  }, [formateData]);

  const handlePayment = () => {
    setModal(!modal);
  };

  const handleProcced_To_payment = () => {
    const [startDate, endDate] = month.split("|");
    const ReqBody = {
      empId: employeeId,
      start_date: startDate,
      end_date: endDate,
    };
    Procced_To_Payment(ReqBody, {
      onSuccess: () => {
        // navigate("/expense/expenses/employeeList",{replace: true }); // 👈 navigate only here
        //  navigate(-2 as unknown, { replace: true });
        navigate(-1 as unknown as string);
      },
    });
  };

  const hasData = employeeExpense && Object.keys(employeeExpense).length > 0;

  const downloadExcelGet = async () => {
    const params: Record<string, any> = {
      month:
        auditScreenStatus_redux === true
          ? AduditSlice_filter.filter.month.id
          : expenseSlice_filter.month.id,
      IsExpense: auditScreenStatus === undefined ? 1 : 0,
    };

    const queryString = new URLSearchParams(params).toString();

    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.EXPENSE.GET_EXCEL_DOWNLOAD_LIST_BY_DATE}/${employeeId}?${queryString}`
      );
      const { success, intervalTime, fileDownloadId } = response?.data?.data || null;
         
     console.log('success, intervalTime, fileDownloadId',success, intervalTime, fileDownloadId);


      if (success && fileDownloadId) {

        startPolling(fileDownloadId,intervalTime, {
          onStatusUpdate: (excelStatus: string) => {
            setExcelStatus(excelStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },

          onFailed: (msg: any) => {
            showToast.error(msg || "onFalied error in Empolyee report excel");
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "onExpired error in Empolyee report excel");
            stopPolling();
            setLoadingExcel(false);
            
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "onDelete error in Empolyee report excel");
            stopPolling();
            setLoadingExcel(false);
          },
        });
      }
    } catch (error) {
      console.log("Error while downloading excel in EmployeeView", error);
    }
  };

  return (
    <div className="p-2" style={{ maxWidth: "100%" }}>
      <PageHeader
        title={"Employee Expense View"}
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />

      {/* <div
        style={{
          // flexWrap: "wrap", 
          maxWidth: "100%",
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          alignItems: "start",
          // alignItems: "flex-start"
        }}
      >
        {hasData ? (
          <WithImageShadowCard
            EmployeeMedia={`${employeeExpense?.EmployeeMedia}`}
            name={
              `${employeeExpense?.FirstName || "-"} ${
                employeeExpense?.LastName || "-"
              }` || ""
            }
            id={`${employeeExpense?.EmployeeCode || "-"}` || ""}
            role={`${employeeExpense?.Designation || "-"}` || ""}
            email={`${employeeExpense?.Email || "-"}` || ""}
            phone={`${employeeExpense?.Phone || "-"}` || ""}
          />
        ) : (
          <CardShimmer profile={true} />
        )}
        {hasData ? (
          <ReusableCard
            extraInfo={{
              "Expense class": employeeExpense?.ExpenseClass || "-",
              HQ: employeeExpense?.HQ || "-",
              "Org Unit": employeeExpense?.UnitName || "-",
              "Total Requested": employeeExpense?.ExpenseReqAmt || "-",
            }}
          />
        ) : (
          <CardShimmer />
        )}
        {hasData ? (
          <ReusableCard
            extraInfo={{
              "Total working days":
                `${
                  employeeExpense?.TripTypeTotal?.HQ +
                    employeeExpense?.TripTypeTotal?.["EX-HQ"] +
                    employeeExpense?.TripTypeTotal?.LOS +
                    employeeExpense?.TripTypeTotal?.OS || "0"
                } days` || "",
              // "Total working days":`${(employeeExpense?.AttendanceTotal+employeeExpense?.TripTypeTotal?.HQ + employeeExpense?.TripTypeTotal?.["EX-HQ"] + employeeExpense?.TripTypeTotal?.LOS+employeeExpense?.TripTypeTotal?.OS)|| "0"} days` || "",
              "HQ: ":
                `${employeeExpense?.TripTypeTotal?.HQ || "0"}  days` || "",
              " Ex-HQ ":
                `${employeeExpense?.TripTypeTotal?.["EX-HQ"] || "0"} days` ||
                "",
              "LOS ":
                `${employeeExpense?.TripTypeTotal?.LOS || "0"} days` || "",
              Outstation:
                `${employeeExpense?.TripTypeTotal?.OS || "0"} days` || "",
            }}
          />
        ) : (
          <CardShimmer />
        )}
        {hasData ? (
          <ReusableCard
            extraInfo={{
              "Submitted date":
                ` ${employeeExpense?.wfSubmit?.CreatedAt || "-"}` || "",
              // ` ${employeeExpense?.submitted || "-"}` || "",
              "Approved date ":
                `${employeeExpense?.wfApprove?.CreatedAt || "-"}` || "",
              "Audited date":
                `${employeeExpense?.wfAudit?.CreatedAt || "-"}` || "",
              "Total working days ":
                `${
                  employeeExpense?.TripTypeTotal?.["EX-HQ"] +
                    employeeExpense?.TripTypeTotal?.LOS +
                    employeeExpense?.TripTypeTotal?.OS || "0"
                } days` || "",
            }}
          />
        ) : (
          <CardShimmer />
        )}
      </div> */}
      <Container fluid>
        <Row className="g-3 justify-content-center align-items-start">
          <Col xs="12" sm="6" md="4" lg="3">
            {hasData ? (
              <WithImageShadowCard
                EmployeeMedia={`${employeeExpense?.EmployeeMedia}`}
                name={`${employeeExpense?.FirstName || "-"} ${
                  employeeExpense?.LastName || "-"
                }`}
                id={`${employeeExpense?.EmployeeCode || "-"}`}
                role={`${employeeExpense?.Designation || "-"}`}
                email={`${employeeExpense?.Email || "-"}`}
                phone={`${employeeExpense?.Phone || "-"}`}
              />
            ) : (
              <CardShimmer profile={true} />
            )}
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            {hasData ? (
              <ReusableCard
                extraInfo={{
                  "Expense class": employeeExpense?.ExpenseClass || "-",
                  HQ: employeeExpense?.HQ || "-",
                  "Org Unit": employeeExpense?.UnitName || "-",
                  "Total Requested": employeeExpense?.ExpenseReqAmt || "-",
                }}
              />
            ) : (
              <CardShimmer />
            )}
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            {hasData ? (
              <ReusableCard
                extraInfo={{
                  "Total working days": `${
                    Number(employeeExpense?.TripTypeTotal?.HQ || 0) +
                    Number(employeeExpense?.TripTypeTotal?.["EX-HQ"] || 0) +
                    Number(employeeExpense?.TripTypeTotal?.LOS || 0) +
                    Number(employeeExpense?.TripTypeTotal?.OS || 0)
                  } days`,
                  "HQ: ": `${employeeExpense?.TripTypeTotal?.HQ || 0} days`,
                  "Ex-HQ": `${
                    employeeExpense?.TripTypeTotal?.["EX-HQ"] || 0
                  } days`,
                  LOS: `${employeeExpense?.TripTypeTotal?.LOS || 0} days`,
                  Outstation: `${employeeExpense?.TripTypeTotal?.OS || 0} days`,
                }}
              />
            ) : (
              <CardShimmer />
            )}
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            {hasData ? (
              <ReusableCard
                extraInfo={{
                  "Submitted date": `${
                    employeeExpense?.wfSubmit?.CreatedAt || "-"
                  }`,
                  "Approved date": `${
                    employeeExpense?.wfApprove?.CreatedAt || "-"
                  }`,
                  "Audited date": `${
                    employeeExpense?.wfAudit?.CreatedAt || "-"
                  }`,
                  "Other days": `${
                    Number(employeeExpense?.TripTypeTotal?.["EX-HQ"] || 0) +
                    Number(employeeExpense?.TripTypeTotal?.LOS || 0) +
                    Number(employeeExpense?.TripTypeTotal?.OS || 0)
                  } days`,
                }}
              />
            ) : (
              <CardShimmer />
            )}
          </Col>
        </Row>
      </Container>

      <ExpenseAccordion flushList={formateData} labels={labels} />

      {/* show only Aduti time */}
      {auditScreenStatus && (
        <>
          <div className="d-flex justify-content-start mt-3 gap-2 flex-wrap">
            <Btn
              style={{ backgroundColor: "#43B9B2", color: "white" }}
              type="submit"
              onClick={handlePayment}
            >
              Proceed for Payment
            </Btn>
          </div>
          {modal && (
            <RouteModal
              isOpen={modal}
              toggle={() => setModal(!modal)}
              size="md"
              title={`${MonthString?.label} audited`}
              content={
                <>
                  <Table
                    bordered
                    className="text-capitalize"
                    style={{ borderRadius: "4px" }}
                  >
                    <tbody>
                      <tr>
                        <td>
                          <strong>Total Working days</strong>
                        </td>
                        <td>
                          {employeeExpense?.AttendanceTotal
                            ? employeeExpense?.AttendanceTotal
                            : 0}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <strong>Total FW Calls</strong>
                        </td>
                        <td>{totalFWCalls}</td>
                      </tr>

                      <tr>
                        <td>
                          <strong>totalNCA</strong>
                        </td>
                        <td>{totalNCA}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Total expense submitted</strong>
                        </td>
                        <td>
                          <span>₹</span>
                          {totalExpenseSubmitted}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <strong>Total expense approved</strong>
                        </td>
                        <td>
                          <span>₹</span>
                          {totalExpenseApproved}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <strong>Total expense audited</strong>
                        </td>
                        <td>
                          <span>₹</span>
                          {totalExpenseAudited}
                        </td>
                      </tr>
                    </tbody>
                  </Table>

                  <Table
                    bordered
                    className="text-capitalize"
                    style={{ marginTop: "10px" }}
                  >
                    {/* <tbody>
                      <tr style={{ height: "60px" }}>
                        <td>
                          <strong>Remark</strong>
                        </td>
                        <td>Test Remark</td>
                      </tr>
                    </tbody> */}
                  </Table>
                  <div className="d-flex justify-content-start mt-3 gap-2">
                    <Btn
                      style={{ backgroundColor: "#43B9B2", color: "white" }}
                      type="submit"
                      // disabled
                      onClick={handleProcced_To_payment}
                    >
                      Submit
                    </Btn>
                    <Btn
                      style={{
                        backgroundColor: "#F9FAFC",
                        color: "#000",
                        border: "1px solid #E0E0E0",
                      }}
                      type="button"
                      onClick={() => setModal(!modal)}
                    >
                      Cancel
                    </Btn>
                  </div>
                </>
              }
            />
          )}
        </>
      )}
    </div>
  );
};

const labels = [
  "Date",
  "Trip Type",
  "Trip Location",
  "Requested",
  "Approved",
  "Audited",
  "Total FW",
  "Total NCA",
  "",
];

export default EmployeeExpView;
